export default {choose_newsletter:'Vyberte newslettery ze seznamu.',email_please:'Váš e-mail?'};